
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { T4SlipSummaryReducedEISetup } from "../../../components/T4Slip";

export interface IT4SlipSummaryReducedEISetupPage {}

export const T4SlipSummaryReducedEISetupPage: FC<IT4SlipSummaryReducedEISetupPage> =
  () => {
    return (
      <AuthenticatedLayout
        pageTitle="T4 Summary Reduced EI"
        breadcrumbCurrentPageName=""
        breadcrumbLinks={[
          // { text: "Compliance", navigateTo: "/compliance/t4/list" },
          // { text: "T4", navigateTo: "/compliance/t4/list" },
          // {
          //   text: "T4 Summary Reduced EI",
          //   navigateTo: "/compliance/t4/summary-reduced-ei",
          // },
        ]}
        mainContents={
          <T4SlipSummaryReducedEISetup testId="t4-summary-reduced-ei-setup" />
        }
      />
    );
  };
